export enum ClientMessages {
  activeText = "global.activeText"
}

export interface TranslationClientMessages {
  [ClientMessages.activeText]: string;
}
